export default __webpack_public_path__ + "static/media/TeamPhoto.46829d71.jpg";